import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
})
export class BadgeComponent {
  severity = input<'critical' | 'high' | 'medium' | 'low' | 'info' | 'none'>('none');
  label = input<string>();

  severityClass = computed(() => `badge-${this.severity().toLowerCase()}`);
}
